<script setup>
  defineProps({
    hasGap: {
      type: Boolean,
      default: true
    }
  })
</script>

<template>
  <div
    class="grid lg:grid-cols-12"
    :class="hasGap ? 'gap-6 lg:gap-12' : ''"
  >
    <slot />
  </div>
</template>
